import update from 'immutability-helper';
import ActionTypes from '../constants/action-types';
import { ExperienceState } from '../types';
import { RootActionTypes } from '../../../stores/types';

type State = ExperienceState['entities']['priceFormat'];

const initialState: State = {};

export default function (state: State = initialState, action: RootActionTypes): State {
  switch (action.type) {
    case ActionTypes.GET_PRICE_FORMAT_SUCCESS:
    case ActionTypes.UPDATE_PRICE_FORMAT_SUCCESS:
      return update(state, { $set: action.payload });
    default:
      return state;
  }
}
